import React, { useState } from 'react';
import * as yup from 'yup';
import { Grid } from '@material-ui/core';
import {
  ItemForm,
  FormInput,
  FormSwitch,
} from '..';
import { User } from '../../types/items';
import { Loadable } from '../../store/types';
import { useTitle } from '../../hooks';
import SetupPhoneDialog from './SetupPhoneDialog/SetupPhoneDialog';
import OpenSetupPhoneButton from './SetupPhoneDialog/OpenSetupPhoneButton';

const userSchema = yup.object().shape({
  project_send_email: yup.bool(),
  project_send_sms_when_ready: yup.bool(),
  phone_sms: yup.string().max(20).nullable(),
});

type Props = {
  creatingMode?: boolean;
  currentMode?: boolean;
  record: Loadable<User>;
  onSubmit: (record: User) => void;
  preventCancelChanges?: boolean;
  backToListLink?: boolean;
  title?: string;
  showPrivateFields?: boolean;
};

const FormUserNotifications = ({
  creatingMode = false,
  record: { loading, data },
  onSubmit,
  preventCancelChanges = false,
  showPrivateFields = false,
}: Props) => {
  useTitle(data?.ref.full_name_first_last);

  const canEdit = data?.permissions.can_edit || false;
  const [showMobileSetup, setShowMobileSetup] = useState(false);

  return (
    <>
      {!loading
        && (
          <ItemForm
            creatingMode={creatingMode}
            initialValues={data}
            validationSchema={userSchema}
            onSubmit={onSubmit}
            loading={loading}
            editPermitted={Boolean(data?.permissions.can_edit)}
            enableReinitialize
            preventCancelChanges={preventCancelChanges}
          >
            <Grid container spacing={4}>
              <Grid item xs={12}>
                <FormSwitch
                  topLabel="Email notifications"
                  label="Receive email notifications"
                  name="project_send_email"
                  disabled={!canEdit}
                />
              </Grid>
              <>
                <Grid item xs={12}>
                  <FormSwitch
                    topLabel="Mobile notifications"
                    label={'Receive mobile text notifications when video is "Ready to Review"'}
                    name="project_send_sms_when_ready"
                    disabled={!canEdit}
                  />
                </Grid>
                {
                  data && data.phone_sms && (
                    <Grid item sm={6} xs={12}>
                      <FormInput
                        label="Phone Number"
                        name="phone_sms"
                        disabled
                      />
                    </Grid>
                  )
                }

                {showPrivateFields
                && (
                  <Grid item xs={12}>
                    <OpenSetupPhoneButton
                      updatePhoneTitle={Boolean(data && data.phone_sms)}
                      onClick={() => setShowMobileSetup(true)}
                      disabled={!data?.project_send_sms_when_ready}
                    />
                    <SetupPhoneDialog
                      phoneType="sms_phone"
                      open={showMobileSetup}
                      onCloseHandler={() => setShowMobileSetup(false)}
                    />
                  </Grid>
                )}
              </>
            </Grid>
          </ItemForm>
        )}
    </>
  );
};

export default FormUserNotifications;
